<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>仓库设置</span>
      </div>
    </div>
    <div class="item-box-content" style="padding-bottom:0px;">
      <el-form>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="queryParams.column">
                <el-option
                  v-for="(item,index) in codeSelect"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button type="primary" @click="onSearch">搜索</el-button>
              <el-button @click="resetProduct">重置</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item>
              <el-button type="primary" @click="onAddOrEditUnit(0)">新增</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="box-table" :style="{height:tableHeight+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="list"
        :max-height="tableHeight"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="code" fixed="left" label="序号" type="index" width="60px"></el-table-column>
        <el-table-column fixed="left" label="仓库编码" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class='line-limit-length'>{{scope.row.storageNumber}}</div>
          </template>
        </el-table-column>
        <el-table-column  label="仓库名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class='line-limit-length'>{{scope.row.storageName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="联系人" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class='line-limit-length'>{{scope.row.storageAdmin}}</div>
          </template>
        </el-table-column>
        <el-table-column label="联系电话" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class='line-limit-length'>{{scope.row.storagePhone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="省份" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class='line-limit-length'>{{scope.row.provice}}</div>
          </template>
        </el-table-column>
        <el-table-column label="市(区)" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class='line-limit-length'>{{scope.row.city}}</div>
          </template>
        </el-table-column>
        <el-table-column label="区(县)" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class='line-limit-length'>{{scope.row.district}}</div>
          </template>
        </el-table-column>
        <el-table-column label="详细地址" width="200px" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class='line-limit-length'>{{scope.row.storageAddress}}</div>
          </template>
        </el-table-column>
        <el-table-column label="是否启用" width="80px">
          <template slot-scope="scope">
            <div>
              <el-switch
                v-model="scope.row.flag"
                :active-value="active"
                :inactive-value="inactive"
                @change="onApply(scope.row)"
                active-color="#276CFF"
              ></el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="仓库信息">
          <template slot-scope="scope">
            <div class="approval line-limit-length" @click="onUpdateOrEditUnit(1,scope.row)">详情</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination" style="padding-top:20px">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
    <!-------------- 新增仓库信息 -------------->
    <house-message-brand @updateStorage="updateStorage" ref="addEditBrandRefs"></house-message-brand>
    <!-- -----详情仓库信息------- -->
    <house-update-brand ref="updateRef" @addStorageBasesVo="addStorageBasesVo"></house-update-brand>
    <!-------------- 判断锁库弹窗 -------------->
    <apply-stock-tip @update="update" @update1="update1" ref="judgmentRefs"></apply-stock-tip>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { codeSelect } from './util/data'
import applyStockTip from './dialog/applyStockTip'
import houseMessage from './dialog/houseMessage'
import updateMessage from './dialog/upadteMessage'
import { queryStorage, queryStorageProductLock } from '@/api/storage/storage'

export default {
  components: {
    'house-message-brand': houseMessage,
    'apply-stock-tip': applyStockTip,
    pagination,
    'house-update-brand': updateMessage
  },
  data () {
    return {
      tableHeight: window.innerHeight - 420,
      queryParams: {
        column: ''
      },
      params: {
        endValue: '',
        value: '',
        expression: ''
      },
      flag: 0,
      contractScreenCondition: [],
      codeSelect: codeSelect,
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数,
      active: 1, // 启用
      inactive: 0, // 停用
      tempList: []

    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 详细资料
    getList () {
      const params = {
        criteriaVoList: [...this.tempList],
        queryPageName: ''
      }
      queryStorage(this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.obj.total
            this.loadingTable = false
            res.data.obj.records.forEach(ele => {
              if (ele.province) {
                const arr = ele.province.split('-')
                ele.provice = arr[0]
                ele.city = arr[1]
                ele.district = arr[2]
              }
            })
            this.list = res.data.obj.records
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 搜索
    onSearch () {
      if (
        this.params.value === '' ||
        this.params.value === undefined ||
        this.queryParams.column === undefined
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.pageSize = 30
        this.currentPage = 1
        this.tempList = this.$queryParams(this.queryParams, this.params)
        this.getList()
      }
    },
    // 重置
    resetProduct () {
      this.tempList = []
      this.pageSize = 30
      this.currentPage = 1
      this.params.value = ''
      this.queryParams = {
        codeSelect: ''
      }
      this.getList()
    },
    // 新增/修改 仓库信息窗口 type = 0 新增 type = 2 修改
    onAddOrEditUnit (type, row) {
      this.$refs.addEditBrandRefs.onInitialize(type, row)
    },
    onUpdateOrEditUnit (type, row) {
      this.$refs.updateRef.onInitialize(type, row)
    },
    onApply (row) {
      if (row.flag === 1) {
        // flag 为0 时,可启用仓库
        this.$refs.judgmentRefs.onInitialize(row.flag, row)
      } else {
        //  flag 为 1 时，仓库设置-判断是否存在锁库，code 1 有锁库，0 没有锁库
        queryStorageProductLock(row.sbId)
          .then(res => {
            if (res.data.code === 200) {
              this.$refs.judgmentRefs.onInitialize(res.data.obj, row)
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    // 启用/停用
    update (val) {
      this.getList()
    },
    update1 (val) {
      this.getList()
    },
    // 对话框
    updateStorage () {
      this.getList()
    },
    addStorageBasesVo () {
      this.getList()
    },
    // 发起收款
    onInitiateCollection () {
      this.$router.push({ name: 'initiateCollection' })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 收款申请详情
    onDetails () {
      this.$router.push({ name: 'collectionApplicationDetails' })
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
